import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Accordion, Grid, Icon, Label, Segment } from "semantic-ui-react";
import ProductPermissionsSubgrid from "../product-permissions-subgrid";

const ProductPermissionsRow = ({ agency_id, agency_name, id, index, handleChange, permissionRows }) => {
  const intl = useIntl();
  const isAdminAgency =
    permissionRows.length === 1 &&
    permissionRows[0].advertisers.length === 0 &&
    permissionRows[0].seller_ids.length === 0 &&
    permissionRows[0].brands.length === 0;
  const isActive = index === id;

  return (
    <Segment
      basic
      style={{ padding: "0" }}
    >
      <Accordion
        fluid
        styled
      >
        <Accordion.Title
          active={isActive}
          index={id}
          onClick={() => handleChange(id)}
        >
          <Grid columns={16}>
            <Grid.Column width={15}>
              <Grid columns="equal">
                <Grid.Column style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                  <h3 style={{ marginBottom: "0px" }}>{agency_name ?? `Agency-${agency_id}`}</h3>
                  {isAdminAgency && (
                    <Label
                      horizontal
                      size="tiny"
                    >
                      {intl.formatMessage({
                        id: "LABEL_ADMIN",
                        defaultMessage: "Admin",
                      })}
                    </Label>
                  )}
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <Icon
                name="chevron down"
                style={{ transform: isActive ? "rotate(-180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }}
              />
            </Grid.Column>
          </Grid>
        </Accordion.Title>
        <Accordion.Content active={isActive}>
          <ProductPermissionsSubgrid permissionRows={permissionRows} />
        </Accordion.Content>
      </Accordion>
    </Segment>
  );
};

export default ProductPermissionsRow;

ProductPermissionsRow.propTypes = {
  agency_id: PropTypes.number.isRequired,
  agency_name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  permissionRows: PropTypes.array.isRequired,
};
